import React from 'react';
import moment from 'moment';

import { Grid, Typography } from '@material-ui/core';

import Identification from '../Identification';
import { TextField, DateField, ImageField, Step } from '../SteppedForm';

const StepLicense = (props) => {
  return (
    <Step
      id="licence"
      title="Identity Documents (100 points)"
      key={'licence-' + props.state.formdata.orgtype}
      valid={{
        valid: () => props.getApplicant().identified,
        msg: '100 points of identification required'
      }}
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}>
      <Typography variant="body1" class="formQuestion">
        Take a photo or scan your documents and upload here
      </Typography>
      <h4>Driver's Licence (60 points)</h4>
      <Grid container>
        {props.stateconfig().stateid && props.state.formdata.orgtype === 'individual' ? (
          <Grid item xs={12}>
            <TextField
              id="crn"
              modify={(value) => props.toUpperCase(value)}
              label={props.stateconfig().stateid}
              required
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={6}>
          <TextField
            id="licno"
            label="Driver's Licence #"
            help="Please note this is the Driver Licence Number, not the Card Number"
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DateField
            id="licexp"
            maxDate={moment().add(10.25, 'years')}
            disablePast
            label="Driver's Licence Expiry"
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <ImageField
            id="licfront"
            label="Licence (Front)"
            height={128}
            width={192}
            min_filesize={1000}
            max_filesize={5242880}
            acceptAll
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <ImageField
            id="licback"
            label="Licence (Back)"
            height={128}
            width={192}
            min_filesize={1000}
            max_filesize={5242880}
            acceptAll
            required
          />
        </Grid>
      </Grid>
      <Identification
        identity={props.getApplicant().identity}
        minPoints={40}
        documents={props.config.documents}
        excludeOpts={['Driver licence']}
        prompt="Please provide 40 points of additional identification. These documents are required to verify your identity."
        onChange={(data, cb) =>
          props.setState(
            {
              formdata: {
                ...props.state.formdata,
                applicants: [
                  ...props.state.formdata.applicants.map((app, idx) => {
                    if (idx === props.state.applicant_index) {
                      return {
                        ...app,
                        ...data
                      };
                    } else {
                      return app;
                    }
                  })
                ]
              }
            },
            cb
          )
        }
      />
    </Step>
  );
};

export default StepLicense;
